module.exports = __webpack_public_path__ + "img/embedded7.d23edca7.png";